module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 020.537be539.jpg";